var map = {
	"./dsp/Commodity": 805,
	"./dsp/Commodity.jsx": 805,
	"./dsp/LocationSuggestions": 806,
	"./dsp/LocationSuggestions.jsx": 806,
	"./imaging/TableImagingList": 522,
	"./imaging/TableImagingList.jsx": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1272;